import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSiteContext } from '@eti/providers';
import { BoundNew } from '@eti/types';
import { date } from '@eti/utils';

const dateFormatter = (dateToFormat) => date.format(dateToFormat, `yyyy-MM-dd'T'HH:mm:ss`);

const getFlightSpecificAttributes = (boundIndex, bounds) => ({
  [`data-flight-${boundIndex}-arrival-date-time`]: dateFormatter(
    bounds[boundIndex].segments[bounds[boundIndex].segments.length - 1].arrivedAt,
  ),
  [`data-flight-${boundIndex}-arrival-iata`]:
    bounds[boundIndex].segments[bounds[boundIndex].segments.length - 1].destination.code,
  [`data-flight-${boundIndex}-departure-date-time`]: dateFormatter(
    bounds[boundIndex].segments[0].departuredAt,
  ),
  [`data-flight-${boundIndex}-departure-iata`]: bounds[boundIndex].segments[0].origin.code,
});

const getHtmlAttributes = (bounds, nationalityId, locale, currency) => ({
  'data-client-id': '535554',
  'data-ct-product': 'widget',
  'data-currency': currency,
  'data-language': locale,
  'data-partner-name': 'flightnetwork',
  ...(nationalityId && {
    'data-residence-id': nationalityId,
  }),
  ...getFlightSpecificAttributes(0, bounds),
  ...(bounds.length > 1 && {
    ...getFlightSpecificAttributes(1, bounds),
  }),
});

const CarTrawlerWidget = ({ bounds, nationalityId }) => {
  const {
    language: { code: locale },
    siteCurrency: { code: currency },
  } = useSiteContext();

  useEffect(() => {
    const carTrawlerScript = document.createElement('script');
    carTrawlerScript.setAttribute('src', 'https://product-router.cartrawler.com/assets/loader.js');
    carTrawlerScript.setAttribute('data-testid', 'upsell-carTrawler-script');
    carTrawlerScript.setAttribute('type', 'application/javascript');
    document.body.appendChild(carTrawlerScript);
  }, []);

  return (
    <div
      data-testid="upsell-carTrawler-widget"
      {...getHtmlAttributes(bounds, nationalityId, locale, currency)}
    />
  );
};

CarTrawlerWidget.propTypes = {
  bounds: PropTypes.arrayOf(BoundNew),
  nationalityId: PropTypes.string,
};

export default CarTrawlerWidget;
